.hj{color:var(--brand-primary);}